import styled from 'styled-components';
export const CheckboxLabel = styled.span`
  padding-right: 5px;
`;
